/** Tarifas oficiales de Gastos Extras y Servicios — solo Admin / supervisor autorizado. */
import { useEffect, useState } from 'react';
import api from '@/api/axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

const UNIDADES = ['servicio', 'día', 'noche', 'persona', 'viaje', 'km', 'hora'];
const VACIA = { concepto: '', descripcion: '', unidad: 'servicio', costo: 0, precio: 0 };

export const TarifasServicios = ({ onClose }) => {
  const [tarifas, setTarifas] = useState([]);
  const [f, setF] = useState(null);
  const [confirmarId, setConfirmarId] = useState(null);
  const load = () => api.get('/sa/pizarra/tarifas').then((r) => setTarifas(r.data.tarifas || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const guardar = async () => {
    if (!f.concepto.trim()) return toast.error('Escribe el concepto');
    try {
      if (f.id) await api.put(`/sa/pizarra/tarifas/${f.id}`, f);
      else await api.post('/sa/pizarra/tarifas', f);
      toast.success('Tarifa guardada');
      setF(null); load();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Sin permiso'); }
  };
  const borrar = async (id) => {
    try { await api.delete(`/sa/pizarra/tarifas/${id}`); setConfirmarId(null); load(); } catch { toast.error('Sin permiso'); }
  };

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg max-h-[85vh] overflow-y-auto" data-testid="tarifas-dialog">
        <DialogHeader><DialogTitle className="text-sm">⚙ Tarifas de Servicios (Pizarra Inteligente)</DialogTitle>
          <DialogDescription className="text-[10px] text-[#6B6B6B]">Solo administración define costo y precio autorizado. Los vendedores solo consultan.</DialogDescription>
        </DialogHeader>
        <Button size="sm" className="bg-[#7352B5] text-white font-bold" onClick={() => setF(VACIA)} data-testid="tarifa-nueva-btn">+ Nueva tarifa</Button>
        {f && (
          <div className="border border-[#B9A5D9] rounded-lg p-2 space-y-1.5" data-testid="tarifa-form">
            <Input placeholder="Concepto (ej. Mano de obra / instalación)" value={f.concepto} onChange={(e) => setF({ ...f, concepto: e.target.value })} className="h-8 text-xs" data-testid="tarifa-concepto" />
            <div className="grid grid-cols-3 gap-1.5">
              <select value={f.unidad} onChange={(e) => setF({ ...f, unidad: e.target.value })} className="h-8 px-2 text-xs rounded-md border border-[#B9A5D9]" data-testid="tarifa-unidad">
                {UNIDADES.map((u) => <option key={u}>{u}</option>)}
              </select>
              <Input type="number" placeholder="Costo Q" value={f.costo || ''} onChange={(e) => setF({ ...f, costo: Number(e.target.value) })} className="h-8 text-xs" data-testid="tarifa-costo" />
              <Input type="number" placeholder="Precio Q" value={f.precio || ''} onChange={(e) => setF({ ...f, precio: Number(e.target.value) })} className="h-8 text-xs" data-testid="tarifa-precio" />
            </div>
            <div className="flex gap-1.5">
              <Button size="sm" variant="outline" className="flex-1 text-xs" onClick={() => setF(null)}>Cancelar</Button>
              <Button size="sm" className="flex-1 bg-[#7352B5] text-white text-xs font-bold" onClick={guardar} data-testid="tarifa-guardar">Guardar</Button>
            </div>
          </div>
        )}
        <div className="divide-y divide-[#F4EFFB]" data-testid="tarifas-lista">
          {tarifas.map((t) => (
            <div key={t.id} className="py-1.5 flex items-center gap-2 text-xs">
              <span className="flex-1"><b>{t.concepto}</b> · {t.unidad} · costo Q{t.costo} · <span className="text-[#38205F] font-black">precio Q{t.precio}</span></span>
              {confirmarId === t.id ? (
                <span className="flex items-center gap-1 text-[10px] font-black" data-testid={`tarifa-confirmar-${t.id}`}>
                  <span className="text-red-500">¿Eliminar?</span>
                  <button onClick={() => borrar(t.id)} className="px-2.5 py-1.5 rounded-lg bg-red-500 text-white" data-testid={`tarifa-borrar-si-${t.id}`}>Sí</button>
                  <button onClick={() => setConfirmarId(null)} className="px-2.5 py-1.5 rounded-lg border border-[#B9A5D9] text-[#6B6B6B]" data-testid={`tarifa-borrar-no-${t.id}`}>No</button>
                </span>
              ) : (
                <>
                  <button onClick={() => setF(t)} className="text-[#7352B5] font-bold px-2 py-1.5" data-testid={`tarifa-editar-${t.id}`}>✎</button>
                  <button onClick={() => setConfirmarId(t.id)} className="text-red-400 font-bold px-2 py-1.5" data-testid={`tarifa-borrar-${t.id}`}>✕</button>
                </>
              )}
            </div>
          ))}
          {tarifas.length === 0 && <p className="text-[11px] text-[#6B6B6B] italic py-2">Sin tarifas — los gastos quedarán «Precio pendiente de autorización».</p>}
        </div>
      </DialogContent>
    </Dialog>
  );
};
